/**
 * HELIX Theme - Public Exports
 *
 * Usage:
 *   import { t, helixTheme, ragColors, typo, tableTypo } from '@/theme';
 *
 * Typography (Executive Mode default):
 *   typo.body = 15px, typo.secondary = 13px, typo.micro = 11px
 *   tableTypo.bodySize = 14px, tableTypo.headerSize = 12px
 */

export {
  helixTheme,
  t,
  typo,
  tableTypo,
  badgeTypo,
  ragColors,
  severityColors,
  urgencyColors,
  confidenceColors,
  evidenceStatusColors,
  statusColors,
} from './helixTheme';

export type { HelixTheme, HelixColors, ColorKey } from './helixTheme';
